import { render } from "./DataManage.vue?vue&type=template&id=465e0d16&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"

import "./DataManage.vue?vue&type=style&index=0&id=465e0d16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465e0d16"]])

export default __exports__